module.exports = __webpack_public_path__ + "static/img/fold.fea392.png";